export const GYM_TYPES = [
  'Home Gym',
  'Commercial Gym',
  'CrossFit Affiliate',
  'Functional Fitness',
  'Powerlifting',
  'Hybrid',
  'Hotel Gym',
  'Athletic Facility',
  'Bootcamp',
  'Hyrox',
  'Community Fitness Center',
  'Martial Arts',
  'Other',
]

// Currently showing a zircle around zip codes with a radius of about 1.5km
export const APPROX_GYM_CIRCLE_RADIUS_METERS = 1500
